import type {TranslateT} from '@freckle/educator-entities/ts/common/helpers/translate'

export type RosterFileTypeT = 'courses' | 'teachers' | 'students' | 'enrollments'

export function getFileName(t: TranslateT, filetype: RosterFileTypeT): string {
  switch (filetype) {
    case 'courses':
      return t('IMPORT_ROSTER_CSV_FILENAME_CLASSES')

    case 'teachers':
      return t('IMPORT_ROSTER_CSV_FILENAME_TEACHERS')

    case 'students':
      return t('IMPORT_ROSTER_CSV_FILENAME_STUDENTS')

    case 'enrollments':
      return t('IMPORT_ROSTER_CSV_FILENAME_ENROLLMENTS')

    default:
      throw new Error(`Unrecognized Roster CSV file type ${filetype}`)
  }
}
